import { CONTACTS } from 'constants/Entities';
import BASE_CONFIG from 'containers/contacts/TableConfig';
import { getMarketingStatusColumn } from 'components/TableCells/MarketingStatusCell/column';
import { setMarketingConsentContact } from 'services/MarketingConsentService';

const ALLOWED_COLS = ['nombre', 'apellidos', 'empresa', 'email'];

export default ({ onClickCheckbox, selectionToken, spamchimp, canEdit } = {}) => {
    const tableParams = {
        ...(onClickCheckbox ? { contact: { onClickCheckbox } } : {}),
        spamchimp,
        ...(canEdit !== undefined ? { canEdit } : {}),
    };
    const base = BASE_CONFIG(tableParams);

    const marketingColumn = getMarketingStatusColumn({
        minWidth: 160,
        setMarketingConsent: setMarketingConsentContact,
    });

    return {
        ...base,
        useFiltersDrawer: false,
        filterKey: 'recipientsContacts',
        quickFilters: [
            'marketingStatus',
            ...base.quickFilters.filter((id) => id !== 'marketingStatus'),
        ],
        columnSelectorSections: undefined,
        withEntitySelection: true,
        selectionFor: 'marketingCampaigns',
        selectionEntity: 'contacts',
        selectionToken,
        isLocalSelection: false,
        columnDefs: [
            ...base.columnDefs
                .filter((col) => ALLOWED_COLS.includes(col.colId))
                .map(({ width, suppressSizeToFit, ...col }) => ({ ...col, minWidth: width })),
            marketingColumn,
        ],
    };
};
